
import jwt from "jsonwebtoken";
import tokCheck from "../Connections/_Utils/utilsCodes";
import { useContext } from "react";
import { RestMenuContext } from "../Contexts/RestMenu_Context";
import utilsRestMenus from "../Connections/_Utils/utilsRestMenus";



const getRandomProductsToList = (menuList, numberToGet, withOutThis) => {
    const allProducts = menuList.buisMenu.flatMap(section => section.Products);
    let randomSelection = "";
    if (withOutThis) {
        let theProds = allProducts.filter(prod => prod._id !== withOutThis._id)
        randomSelection = getRandomItems(theProds, numberToGet);
    } else {
        randomSelection = getRandomItems(allProducts, numberToGet);
    }

    return randomSelection;
};



const getRandomItems = (arr, num) => {
    const shuffled = arr
        .map(value => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);
    return shuffled.slice(0, num);
};



const validPhone = (phone) => {
    if (phone && phone !== "") {
        var clearPhone = phone.replace('-', '');
        var pattern = new RegExp(/^[0-9\b]+$/);
        if (!pattern.test(clearPhone)) {
            return false
        } else if (clearPhone.length !== 10 && clearPhone.length !== 9) {
            return "<p>יש להזין מספר טלפון תקין</p>";
        }
        else {
            return "";
        }
    }
    else {
        return "<p>יש להזין מספר טלפון תקין</p>";
    }
}

const validEmail = (email) => {
    if (email !== "") {
        var pattern = new RegExp(/^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i);
        if (!pattern.test(email)) {
            return "<p>יש להזין כתובת מייל תקינה<p>";
        }
        else {
            return "";
        }
    }
    else {
        return "<p>יש להזין כתובת מייל תקינה<p>";
    }
}


const checkToken = async (toeknToCheck) => {

    let theUsr = await tokCheck.checkToken(toeknToCheck);
    return theUsr;

}

const connCheck = async () => {
    const usrtoken = localStorage.getItem('napoUsrToken');

    if (usrtoken) {
        const user = jwt.decode(usrtoken);

        let usr = await checkToken(usrtoken);

        if (usr.user != null) {
            return usr;
        }
        else {
            localStorage.removeItem('napoUsrToken');
            return null;

            // goLogin();
        }

    }
    else {
        return null;
    }
}

//המחיר הכולל של המוצר כולל תוספות מחיר של נלווים
const getItemTotalPrice = (item) => {

    let totItms = 0;

    // Map through prodOptions and calculate total price for selected options
    item.prodOptions?.forEach((optionGroup) => {
        const selectedOptions = optionGroup.options.filter((opt) => opt.selected);
        totItms += getSelectedOptionsPrice(selectedOptions); // שימוש בפונקציה getSelectedOptionsPrice
    });

    // Calculate and return the total price
    return (parseInt(item.basePrice) + parseFloat(totItms)) * parseInt(item.mount);

}

const getSelectedOptionsPrice = (selectedOptions) => {
    // Initialize total items to 0
    let totItms = 0;

    // Check if selectedOptions array is not empty
    if (selectedOptions.length > 0) {
        totItms = selectedOptions.reduce((total, item) => {
            // Parse addToPrice to ensure it's a number or default to 0
            const addToPrice = parseFloat(item.addToPrice || 0);

            // Check if addToPrice is valid and greater than 0
            if (!isNaN(addToPrice) && addToPrice > 0) {
                // Ensure mount is at least 1
                const mount = item.mount > 0 ? item.mount : 1;

                // Add to the total
                return total + addToPrice * mount;
            }

            // Skip invalid items
            return total;
        }, 0);
    }
    // Return the final total, parsed as a float for safety
    return parseFloat(totItms);
};

const getOrderPrice = (theOrder) => {
    let tot = 0;

    theOrder.items.map((item) => {
        // חישוב מחיר בסיסי
        const basePrice = parseFloat(item.basePrice);

        // חישוב מחיר האופציות הנבחרות
        let optionsPrice = 0;
        item.prodOptions?.map((optionGroup) => {
            const selectedOptions = optionGroup.options.filter((opt) => opt.selected);
            optionsPrice += getSelectedOptionsPrice(selectedOptions);
        });

        // חישוב המחיר הכולל של המוצר עם האופציות והכפלתו בכמות
        const totalItemPrice = (parseFloat(basePrice) + parseFloat(optionsPrice)) * parseInt(item.mount);

        // הוספת המחיר הכולל ל-tot
        tot += totalItemPrice;


    });

    return tot;
};

const fixProductPrice = (myProd, theOrder) => {
    // שמירת המחיר הבסיסי אם עדיין לא קיים
    if (!myProd.basePrice) {
        myProd.basePrice = myProd.prodPrice;
    }

    // התחלת המחיר מהמחיר הבסיסי
    myProd.prodPrice = myProd.basePrice;

    // בדיקה בכל הפריטים ב-theOrder
    theOrder.items.forEach((item) => {
        // בדיקה אם המוצר מתאים
        if (item._id === myProd._id) {
            // מעבר על כל האפשרויות של המוצר
            item.prodOptions.forEach((prodOption) => {
                prodOption.options.forEach((option) => {
                    // בדיקה אם האפשרות נבחרה ויש לה תוספת מחיר
                    if (option.selected && option.addToPrice) {
                        // עדכון המחיר של המוצר
                        myProd.prodPrice += parseFloat(option.addToPrice);
                    }
                });
            });
        }
    });

    // החזרת המוצר עם המחיר המעודכן
    return myProd;
};


// const fixProductPriceByMenu = async (prdct, theOrder) => {

//     let restMenu;
//     try {
//         // קבלת תפריט המסעדה
//         restMenu = await utilsRestMenus.getRestMenu();
//     } catch (error) {
//         console.error("Error fetching rest menu:", error);
//         return null; // במקרה של שגיאה נחזיר null
//     }

//     if (restMenu) {
//         const foundItem = restMenu.buisMenu
//             .flatMap((section) => {
//                 const product = section.Products.find((product) => product._id === prdct._id);
//                 return product ? { product, section } : null;
//             })
//             .find((item) => item !== null);

//         if (foundItem) {
//             let myProd = foundItem.product;

//             // עדכון מחיר הבסיס
//             if (!myProd.basePrice) {
//                 myProd.basePrice = myProd.prodPrice;
//             }
//             myProd.prodPrice = myProd.basePrice; // התחלה ממחיר הבסיס

//             // עדכון מחיר לפי theOrder
//             const orderItem = theOrder.items.find((item) => item._id === myProd._id);
//             if (orderItem) {
//                 orderItem.prodOptions.forEach((prodOption) => {
//                     prodOption.options.forEach((option) => {
//                         if (option.selected && option.addToPrice) {
//                             myProd.prodPrice += parseFloat(option.addToPrice);
//                         }
//                     });
//                 });
//             }

//             return myProd.prodPrice; // החזרת המוצר המעודכן
//         } else {
//             return prdct.prodPrice; // אם לא נמצא מוצר מתאים
//         }
//     } else {
//         return prdct.prodPrice; // במקרה שבו התפריט לא זמין
//     }
// };


const getMenu = () => {

}



const getOrderTotalPrice = (theOrder, delPrc) => {

    let bk = getOrderPrice(theOrder);
    bk += parseInt(delPrc?.delivPrice) || 0;

    return bk;
}



export default {
    getRandomProductsToList,
    getRandomItems,
    validPhone,
    validEmail,
    connCheck,
    getOrderPrice,
    getOrderTotalPrice,
    fixProductPrice,
    // fixProductPriceByMenu,
    getItemTotalPrice,
    getSelectedOptionsPrice
};